import classNames from "classnames";
import { DComponent } from "../DComponent";
export default class CheckoutBtn extends DComponent {
  constructor({
    parent,
    id,
    className,
    textCheckout,
    arrowIcon,
    cartIcon,
    dragIcon,
    state,
    badge,
    onClick = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("CheckoutBtn", className, `dc-${state}`),
      textCheckout,
      arrowIcon,
      cartIcon,
      dragIcon,
      state,
      badge,
    }, true, true);
    this.onClick = onClick;
    this.state = state;
    this.badge = badge;
    this.render();
  }

  static init({
    parent,
    id,
    className,
    textCheckout,
    arrowIcon,
    cartIcon,
    dragIcon,
    state,
    badge,
    onClick = (e) => { },
  } = {}) {
    return new CheckoutBtn({
      parent,
      id,
      className,
      textCheckout,
      arrowIcon,
      cartIcon,
      dragIcon,
      state,
      badge,
      onClick,
    });
  }

  loadStyle() {
    const style = document.createElement("style");
    style.textContent = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.element.append(style);
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.element.on('click', ".dc-box-checkout", (e) => {
      typeof e.preventDefault == "function" && e.preventDefault();
      typeof this.onClick === "function" && this.onClick(e);
    });
  }

  setState(state) {
    this.element.removeClass(`dc-${this.state}`).addClass(`dc-${state}`);
    this.state = state;
  }

  collapse(value) {
    this.element.removeClass("collapseItem").removeClass("expandItem").addClass(value ? "collapseItem" : "expandItem");
  }

  isCollapse() {
    return this.element.hasClass("collapseItem");
  }

  disable(value = true) {
    this.element.removeClass("dc-disabled");
    value && this.element.addClass("dc-disabled");
  }

  animation(value) {
    value ? this.element.find(".dc-cart-icon").addClass("animation") : this.element.find(".dc-cart-icon").removeClass("animation");
  }

  setNotEmpty(value) {
    value ? this.element.addClass("not-empty") : this.element.removeClass("not-empty");
  }

  setText(textCheckout) {
    $(".dc-checkout", this.element).html(textCheckout);
  }

  setBadge(value) {
    $(".dc-badge", this.element).html(value);
    this.badge = value;
  }
}
